export default __webpack_public_path__ + "static/media/category-6.ae7a77de.jpg";